import { render } from "./Project4View.vue?vue&type=template&id=0fc00f3e&scoped=true&ts=true"
import script from "./Project4View.vue?vue&type=script&lang=ts"
export * from "./Project4View.vue?vue&type=script&lang=ts"

import "./Project4View.vue?vue&type=style&index=0&id=0fc00f3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc00f3e"]])

export default __exports__